import ButtonDropdown from "@rio-cloud/rio-uikit/ButtonDropdown";
import { Button } from "@rio-cloud/rio-uikit";

type Items = {
  title: string;
  icon: string;
  onClick: () => void;
};

interface Props {
  items: Items[];
}

const DownloadButton = ({ items }: Props) => (
  <span>
    <ButtonDropdown
      title={
        <Button variant="outline" bsSize="sm" iconOnly>
          <span className="rioglyph rioglyph-download" aria-hidden="true" />
        </Button>
      }
      variant="link"
      iconOnly
      pullRight
      items={items.map((i) => {
        return {
          value: (
            <Button
              variant="link"
              onClick={i?.onClick}
              className="display-flex align-items-center justify-content-start gap-10 width-150"
            >
              <span className={`${i?.icon} text-color-highlight `} />
              <span>{i?.title}</span>
            </Button>
          ),
        };
      })}
    />
  </span>
);

export default DownloadButton;
